module.exports = __webpack_public_path__ + "media/ring3.59b09eff.mp3";